import * as React from 'react';
import { StyledTheaterHeader, LeftBlock, CenterBlock, RightBlock } from './styles';
import CancelButton from '../../../components/MenuManager/Header/HeaderButton/CancelButton';
import { CancelActionOrigin } from '../../MenuManager/constants';
const Translate = require('react-redux-i18n').Translate;

interface TheaterHeaderProps {
	leavePage: () => void;
	sliderIndex: number;
	sliderLength: number;
}

const TheaterHeader = (props: TheaterHeaderProps) => {
	const { leavePage, sliderIndex, sliderLength } = props;

	return (
		<StyledTheaterHeader className="StyledTheaterHeader">
			<LeftBlock className="TheaterHeaderLeftBlock" />
			<CenterBlock className="TheaterHeaderCenterBlock">
				<Translate value="messages.page_index" index={sliderIndex} count={sliderLength} dangerousHTML={true} />
			</CenterBlock>
			<RightBlock className="TheaterHeaderRightBlock">
				<CancelButton actionOrigin={CancelActionOrigin.Theater} leavePage={leavePage} />
			</RightBlock>
		</StyledTheaterHeader>
	);
};

export default TheaterHeader;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Theater/Header/index.tsx